<template>
  <div class="container-fluid py-3 px-4">

    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-card-text display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            SEGUIMIENTO
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            SEGUIMIENTO DE ROTACION DE LOS DISPOSITIVOS
          </p>
        </div>
      </div>
    </div>

    <div class="row align-items-center mb-1 mx-0">
      <!-- Botones -->

      <div class="border border-1 rounded-3 p-3 mb-2">
        <div class="col-12 col-md-6 d-flex flex-wrap gap-2 mb-4 mb-md-0">
          <select class="form-select w-auto" v-model="subCentroSeleccionado">
            <option value="">-- TODOS LOS SUB CENTROS --</option>

            <option v-for="sub in subCentrosUnicos" :key="sub" :value="sub">
              {{ sub }}
            </option>
          </select>

          <button class="btn btn-success boton-estiloCuadrado" title="Reporte de Excel" :disabled="excelCarga"
            @click="descargarExcelSegui">
            <i class="bi bi-file-earmark-excel"></i>
            <b v-if="excelCarga">cargando...</b>
          </button>
          <abbr title="RECARGA DE REPORTE">
            <button @click="reporteSeguimientosExcel" class="btn btn-ligth border border-1 text-primary ms-1">
              <i class="bi bi-arrow-counterclockwise"></i>
            </button>
          </abbr>

          <!-- <div class="col-12 col-md-6 d-flex flex-wrap gap-2 mb-4 mb-md-0">
          <button class="btn btn-warning boton-estiloCuadrado" @click="abrirModal('agregar')">
            <i class="bi bi-plus"></i>
          </button> -->

          <!-- <button class="btn btn-danger boton-estiloCuadrado" :disabled="selectedRows.length === 0"
            @click="eliminarSeleccionados">
            <i class="bi bi-trash"></i>
          </button> -->
        </div>
      </div>

      <!-- Buscador -->
      <div class="border border-1 rounded-3 p-3 mb-2 ">
        <!-- Buscador -->
        <div class="row mb-3 justify-content-end mt-3">
          <div class="d-flex justify-content-end mt-2">
            <span for="" class="input-group-text mt-2 buscar-estiloCuadrado"> <i class="bi bi-search"></i></span>
            <input class="form-control form-control-lg w-25 mt-2 me-2 buscar-estiloCuadrado" type="text"
              aria-label=".form-control-lg example" placeholder="ID / SERIE / APELLIDO / DNI /LINEA" v-model="busqueda"
              @input="busqueda = busqueda.replace(/\s+/g, ''); filtro()"
              @keydown.space.prevent />
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-responsive">
          <table class="table table-bordered ">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th style="text-align: center"><i class="bi bi-boxes"></i></th>
                <th style="text-align: center">ID</th>

                <!-- HISTORIAL -->
                <th>
                  HISTORIAL
                </th>

                <!-- PROYECTO -->
                <th @click="sortBy('empDesLinea')" class="cursor-pointer">
                  PROYECTO
                  <i v-if="sortKey === 'empDesLinea'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'">
                  </i>
                </th>

                <!-- TRABAJADOR -->
                <th @click="sortBy('apellidosNombres')" class="cursor-pointer">
                  TRABAJADOR
                  <i v-if="sortKey === 'apellidosNombres'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'">
                  </i>
                </th>

                <!-- FEC ENTREGA -->
                <th @click="sortBy('movFechaEntrega')" class="cursor-pointer">
                  FEC. ENTREGA
                  <i v-if="sortKey === 'movFechaEntrega'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'">
                  </i>
                </th>

                <!-- FEC DEVOLUCIÓN -->
                <th @click="sortBy('movFechaDevolucion')" class="cursor-pointer">
                  FEC. DEVOLUCION
                  <i v-if="sortKey === 'movFechaDevolucion'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'">
                  </i>
                </th>

                <!-- DISPOSITIVO -->
                <th @click="sortBy('disSerie')" class="cursor-pointer">
                  DISPOSITIVO
                  <i v-if="sortKey === 'disSerie'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'">
                  </i>
                </th>

                <!-- DETALLE TÉCNICO -->
                <th>
                  DETALLE TECNICO

                </th>

                <!-- OBSERVACION -->
                <th>
                  OBSERVACION

                </th>

                <!-- MTO ALQUILER -->
                <th @click="sortBy('hisMonAlquiler')" class="cursor-pointer">
                  MTO. ALQUILER
                  <i v-if="sortKey === 'hisMonAlquiler'"
                    :class="sortOrder === 'asc' ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'">
                  </i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="11" class="text-center align-middle" style="height: 250px;">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100">
                    <div class="spinner-border text-warning" role="status" style="width: 4rem; height: 4rem;"></div>
                    <div class="mt-3 text-secondary fw-semibold fs-5">Filtrando información...</div>
                  </div>
                </td>
              </tr>

              <!-- 📋 Datos -->
              <tr v-else v-for="copia in copiasPaginadas" :key="copia.idMovEquipo"
                class="text-center align-middle text-nowrap reducirTamaño" :class="{
                  'table-danger':
                    (copia.estadoDescripcionColaborador === 'BAJA' ||
                      copia.estadoDescripcionColaborador === 'SUSPENSION') &&
                    copia.movFechaDevolucion === '01/01/1900',

                  'table-warning':
                    copia.estadoDescripcionColaborador === 'LIBRE' &&
                    copia.movFechaEntrega === '01/01/1900'
                }">


                <!-- ACCIONES -->
                <td>
                  <div class="d-flex justify-content-center gap-2">
                    <!-- <button class="btn btn-outline-success btn-sm boton-estiloCuadrado"
                      @click="abrirModal('editar', copia)" title="Editar registro">
                      <i class="bi bi-pencil-fill"></i>
                    </button> -->
                    <button class="btn btn-outline-danger btn-sm boton-estiloCuadrado" @click="generarPDFVue(copia)"
                      title="Generar PDF">
                      <i class="bi bi-filetype-pdf"></i>
                    </button>

                    <label for="file-upload" class="btn btn-outline-primary boton-estiloCuadrado" @click="
                      mandarPdfServicios(
                        copia.idMovEquipo, copia.nroDocumento
                      )
                      ">
                      <i class="bi bi-cloud-upload"></i>
                    </label>
                    <input id="file-upload" class=" " type="file" accept=".pdf" @change="handleFileUpload"
                      ref="fileInput" :key="fileInputKey" />
                    <button class="btn-sm boton-estiloCuadrado" :class="{
                      'btn btn-ligth': copia.estadoArchivo == false,
                      'btn btn-danger': copia.estadoArchivo == true
                    }" title="Generar PDF"><a :class="{
                      'text-danger': !copia.estadoArchivo,
                      'text-white': copia.estadoArchivo,
                    }" :href="url + copia.archivo.split('Tecnologia\\')[1]" target="_blank">
                        <i class="bi bi-file-pdf"></i> </a>
                    </button>

                  </div>
                </td>

                <!-- ID -->
                <td><strong>{{ copia.idMovEquipo }}</strong></td>

                <!-- HISTORIAL -->
                <td>
                  <span :class="{
                    'text-primary fw-bold': copia.asignacion,
                    'text-danger fw-bold': !copia.asignacion
                  }">
                    <i class="bi" :class="{
                      'bi-check-circle-fill text-primary': copia.asignacion,
                      'bi-x-circle-fill text-danger': !copia.asignacion

                    }"></i>
                    {{ copia.asignacion ? 'ASIGNADO' : 'NO ASIGNADO' }}
                  </span>
                </td>

                <!-- PROYECTO -->
                <td class="text-start">
                  <strong>{{ copia.empDesLinea }}</strong><br>
                  <small class="text-muted">{{ copia.desSubCentro }}</small><br>
                  <small class="text-muted">{{ copia.desSubSubCentro }}</small>
                </td>

                <!-- TRABAJADOR -->
                <td class="text-start">
                  <div>
                    <strong>{{ copia.apellidosNombres }}</strong><br>
                    <small class="text-muted">{{ copia.tipoDocumento }} - {{ copia.nroDocumento }}</small><br>
                    <span :class="{
                      'text-success fw-bold': copia.estadoDescripcionColaborador === 'ACTIVO',
                      'text-danger fw-bold': copia.estadoDescripcionColaborador === 'BAJA' ||
                        copia.estadoDescripcionColaborador === 'SUSPENSION',
                      'text-primary fw-bold': copia.estadoDescripcionColaborador === 'LIBRE'
                    }">
                      <i class="bi me-1" :class="{
                        'bi-person-check-fill text-success': copia.estadoDescripcionColaborador === 'ACTIVO',
                        'bi-person-x-fill text-danger': copia.estadoDescripcionColaborador === 'BAJA',
                        'bi-pause-circle-fill text-danger': copia.estadoDescripcionColaborador === 'SUSPENSION',
                        'bi bi-check-circle text-primary': copia.estadoDescripcionColaborador === 'LIBRE'

                      }"></i>
                      ({{ copia.estadoDescripcionColaborador === 'BAJA' ? 'CESADO' : copia.estadoDescripcionColaborador
                      }})
                    </span>
                  </div>
                </td>

                <!-- FEC. ENTREGA -->
                <td>
                  <i class="bi bi-calendar-check text-success"></i>
                  {{ copia.movFechaEntrega === '01/01/1900' ? '--' : copia.movFechaEntrega }}
                </td>

                <!-- FEC. DEVOLUCIÓN -->
                <td>
                  <i class="bi bi-calendar-x text-danger"></i>
                  {{ copia.movFechaDevolucion === '01/01/1900' ? '--' : copia.movFechaDevolucion }}
                </td>

                <!-- DISPOSITIVO -->
                <td class="text-start">
                  <!-- Estado de línea -->
                  <div class="fw-semibold text-dark mb-1">
                    <i class="bi bi-info-circle-fill text-primary me-1"></i>
                    {{ copia.desLinEstado }}
                  </div>

                  <!-- Línea asignada con icono dinámico -->
                  <div class="fw-bold text-primary mb-1">
                    {{ copia.lineaAsignada }}
                  </div>

                  <!-- Serie -->
                  <div class="text-secondary small mb-1">
                    <i class="bi bi-upc-scan me-1 text-muted"></i>
                    Serie: <strong class="text-dark">{{ copia.disSerie }}</strong>
                  </div>

                  <!-- Marca -->
                  <div class="text-muted small">
                    <i class="bi bi-cpu-fill me-1"></i>
                    {{ copia.disMarca }}
                  </div>
                </td>


                <!-- DETALLE TÉCNICO -->
                <td class="text-start">
                  <small>{{ copia.movDetTecnico }}</small>
                </td>

                <!-- OBSERVACIÓN -->
                <td class="text-start">
                  <small>{{ copia.movObservacion }}</small>
                </td>

                <!-- MTO. ALQUILER -->
                <td class="fw-bold text-success">
                  {{ 'S/. ' + copia.hisMonAlquiler.toFixed(2) }}
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>




      <!-- Paginación -->
      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="pagination-info">Página {{ currentPage }} de {{ totalPages }}</span>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
          :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>
    </div>
    <div v-if="modalCargando" class="custom-modal-overlay">
      <div class="custom-modal">
        <div class="d-flex justify-content-center align-items-center gap-3 my-3">
          <b-spinner type="grow" label=""></b-spinner>
          <b-spinner type="grow" label=""></b-spinner>
          <b-spinner type="grow" label=""></b-spinner>
          <b-spinner type="grow" label=""></b-spinner>
          <b-spinner type="grow" label=""></b-spinner>
        </div>

        <p class="text">Subiendo archivo, por favor espera...</p>
      </div>
    </div>

  </div>
  <!-- </div>
  </div> -->
</template>

<script>

import Swal from "sweetalert2";

import { mapGetters } from "vuex";

export default {
  name: "SeguimientoDispositivos",

  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Tecnologia/",
      busqueda: "",
      loading: false,
      selectedRows: [],
      movimientos: [],
      mostrarModal: false,
      modalModo: "agregar",
      modalForm: {},
      personasFiltradas: [],
      movTipDispositivo: "",
      movmov: "",
      movIdTrabajador: "",
      movObservacion: "",
      movDetTecnico: "",
      movFechaEntrega: "",
      movFechaDevolucion: "1900-01-01",
      movEmpresa: "",
      movCenCosto: [],
      movSubCentro: [],
      movSubSubCentro: [],
      CentroCosto: [],
      SubCentroCosto: [],
      CodSubCenCosto: "",
      SubSubCentroCosto: [],
      hisMonAlquiler: 0,
      CodSubSubCentro: "",
      CodCenCosto: "",
      idEmpresa: "",
      currentPage: 1,
      itemsPerPage: 10,
      busquedaSelect: "",
      mostrarLista: false,
      trabajadorSeleccionado: null,
      EstadoDis: [],
      idUsuario: "",
      editarRotac: {},
      idMovEquipo: "",
      movIdDispositivos: [],
      movIdTrabajadores: [],
      movIdDispositivo: "",
      asignacion: false,
      idTrabajador: null,
      ReportRotacionDocumento: null,
      excelCarga: true,
      abortController: null,
      sortKey: '',
      sortOrder: 'asc',
      modalCargando: false,

      dni: '', // Asegúrate de tener este dato cargado
      idMovimiento: '', // también debe venir del contexto o props
      fileInputKey: 0, // para reiniciar el input
      subCentroSeleccionado: "",
    };
  },

  created() {

    this.dniTrabajador = localStorage.getItem("dniUsers");
    this.idUsuario = localStorage.getItem("userId");
    this.idTrabajador = localStorage.getItem("idTrabajdor");


    // const tiempoTranscurrido = Date.now();
    // const hoy = new Date(tiempoTranscurrido);
    // this.movFechaEntrega = hoy.toISOString().slice(0, 10);
    // this.movFechaDevolucion = hoy.toISOString().slice(0, 10);

    this.axios.get(`ParametroData/Parametro/7720`).then((r) => {
      this.EstadoDis = r.data;
    });
    this.obtenerMovimientos();
    this.ObtenerDispositivoRotacion()
    this.ObtenerTrabajadoreMovimiento()
    this.reporteSeguimientosExcel()
  },

 
  computed: {
    ...mapGetters("users", ["DniEmpre"]),

    dispositivosFiltrados() {
      if (!this.busquedaDispositivo) return this.movIdDispositivos;
      return this.movIdDispositivos.filter(d =>
        d.nombreDispositivo.toLowerCase().includes(this.busquedaDispositivo.toLowerCase())
      );
    },
    subCentrosUnicos() {
    const lista = this.movimientos
      .map(m => m.desSubCentro)
      .filter(Boolean); // elimina null / undefined

    return [...new Set(lista)];
  },

    copiasOrdenadas() {
      if (!this.sortKey) return this.copiasFiltradas;

      return this.copiasFiltradas.slice().sort((a, b) => {
        let A = a[this.sortKey];
        let B = b[this.sortKey];

        if (A === '01/01/1900') A = '';
        if (B === '01/01/1900') B = '';

        if (A < B) return this.sortOrder === 'asc' ? -1 : 1;
        if (A > B) return this.sortOrder === 'asc' ? 1 : -1;
        return 0;
      });
    },
    trabajadoresFiltrados() {
      if (!this.busquedaSelect) return [];
      // Filtra usando tu array original "movIdTrabajadores"
      return this.movIdTrabajadores.filter((t) =>
        t.nombre.toLowerCase().includes(this.busquedaSelect.toLowerCase())
      );
    },

    copiasFiltradas() {
  let resultado = this.movimientos;

  // 🔍 filtro por texto
  if (this.busqueda) {
    const texto = this.busqueda.toLowerCase();
    resultado = resultado.filter(d =>
      String(d.idMovEquipo).toLowerCase().includes(texto) ||
      d.disSerie?.toLowerCase().includes(texto) ||
      d.apellidosNombres?.toLowerCase().includes(texto) ||
      d.nroDocumento?.toLowerCase().includes(texto) ||
      d.lineaAsignada?.toLowerCase().includes(texto)
    );
  }

  // 🏷️ filtro por SUB CENTRO
  if (this.subCentroSeleccionado) {
    resultado = resultado.filter(
      d => d.desSubCentro === this.subCentroSeleccionado
    );
  }

  return resultado;
},

    copiasPaginadas() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.copiasOrdenadas.slice(start, start + this.itemsPerPage);
    },

    totalPages() {
      const lista = this.sortKey ? this.copiasOrdenadas : this.copiasFiltradas;
      return Math.ceil(lista.length / this.itemsPerPage);
    },

    // ⭐ NUEVA COMPUTED QUE DECIDE QUÉ MOSTRAR
    filasMostradas() {
      const lista = this.sortKey ? this.copiasOrdenadas : this.copiasFiltradas;

      const start = (this.currentPage - 1) * this.itemsPerPage;
      return lista.slice(start, start + this.itemsPerPage);
    }
  },

  methods: {
    sortBy(column) {
      if (this.sortKey === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = column;
        this.sortOrder = 'asc';
      }
    },
    seleccionarTrabajador(trabajador) {
      this.trabajadorSeleccionado = trabajador;
      this.busquedaSelect = trabajador.nombre; // muestra el nombre seleccionado
      this.mostrarLista = false;

      // Llama a tu método existente con el id del trabajador
      this.recogerIdTraba(trabajador.idTrabajador);
    },
    ocultarLista() {
      // Espera un poco para permitir clic antes de cerrar
      setTimeout(() => (this.mostrarLista = false), 200);
    },
    obtenerMovimientos() {
      try {
        this.axios.get(`Tecnologia/movmientoDispositivos/${this.idTrabajador}`).then((r) => {
          this.movimientos = r.data;
          console.log("movmiento", r.data);
        });
      } catch (error) {
        console.error("Error al obtener movimientos:", error);
      }
    },

    ObtenerDispositivoRotacion() {
      this.axios.get(`Tecnologia/ObtenerDispositivosRotacion`).then((r) => {
        this.movIdDispositivos = r.data;
      });
    },

    ObtenerTrabajadoreMovimiento() {
      this.axios.get(`Tecnologia/ObtenerTrabajadoresMovimiento`).then((r) => {
        this.movIdTrabajadores = r.data;
      });
    },

    async generarPDFVue(copia) {


      console.log(copia)

      this.axios
        .get(
          `Tecnologia/GenerarPdfEntregaMaterial?idEmpresa=${copia.idEmpresa}&empresa=${encodeURIComponent(copia.empresa)}&ruc=${copia.empresaRuc}&direccion=${copia.direccion}&nombreRepresentante=${copia.nombreRepresentante}&tipoDocRepre=${copia.tipoDocRepre}&nroDocRepre=${copia.nroDocRepre}&apellidosNombres=${copia.apellidosNombres}&tipoDocumento=${copia.tipoDocumento}&nroDocumento=${copia.nroDocumento}&trabDireccion=${copia.trabDireccion}&trabCarBoleta=${copia.trabCarBoleta}&desCentroCosto=${copia.desCentroCosto}&desSubSubCentro=${copia.desSubSubCentro}&desSubCentro=${copia.desSubCentro}&disMarca=${copia.disMarca}&disSerie=${copia.disSerie}&linNumero=${copia.lineaAsignada}&linSimCard=${copia.lineaSinCard}&accesorios=${copia.accesorios}&disComentario=${copia.disComentario}&disFechaHoy=${copia.disFechaHoy}&fechaEntrega=${copia.movFechaEntrega}&fechaDevolucion=${copia.movFechaDevolucion}&observacion${copia.movObservacion}&detTecnico${copia.movDetTecnico}`,
          {
            responseType: "blob" // 👈 Importante para recibir el PDF como binario
          }
        )
        .then((r) => {
          // ✅ Crear blob y forzar descarga
          const blob = new Blob([r.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${copia.disSerie}-${copia.apellidosNombres}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          console.error("❌ Error al descargar PDF:", err);
        });

    },

    mandarPdfServicios(idMovimiento, dniTrabajador) {
      this.idMovimiento = idMovimiento
      this.dni = dniTrabajador
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.type !== "application/pdf") {
        Swal.fire("Solo se permiten archivos PDF", "", "warning");
        return;
      }

      this.archivoSeleccionado = file;

      // 🔸 Validar datos antes de enviar
      if (!this.idMovimiento || !this.dni) {
        Swal.fire("Error", "Faltan datos para subir el archivo.", "error");
        return;
      }

      // 🧩 Construir FormData
      const formData = new FormData();
      formData.append("archivo", this.archivoSeleccionado);
      formData.append("idMovimiento", this.idMovimiento);
      formData.append("dni", this.dni);

      try {
        this.modalCargando = true; // Mostrar modal

        const response = await this.axios.post(
          "Tecnologia/SubirDocumentoMovimiento",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        console.log("📦 Respuesta del servidor:", response.data);
        this.obtenerMovimientos();
        this.resetFileInput();
      } catch (error) {
        console.error("❌ Error al subir:", error);
        Swal.fire("Error en la conexión con el servidor", "", "error");
      } finally {
        this.modalCargando = false; // Ocultar modal
      }
    },

    // 🔄 Reiniciar el input file
    resetFileInput() {
      this.archivoSeleccionado = null;
      this.fileInputKey++;
    },

    abrirModal(modo, informacion) {
      this.modalModo = modo;

      if (modo === "editar") {
        this.editarRotac = informacion;
        //this.editarRotac.desLinEstado="001"

        console.log(this.editarRotac);
        this.idMovEquipo = informacion.idMovEquipo;
        this.desLinEstado = informacion.desLinEstado;

        /*this.idEmpresa = informacion.empLinea;
        this.CodCenCosto = informacion.codCentroCosto;
        this.CodSubCenCosto = informacion.codSubCentro;
        this.CodSubSubCentro = informacion.codSubSubCentro;*/
        this.movTipDispositivo = informacion.movTipDispositivo;
        this.movIdDispositivo = informacion.movIdDispositivo;
        this.movIdTrabajador = informacion.movIdTrabajador;
        this.movObservacion = informacion.movObservacion;
        this.movDetTecnico = informacion.movDetTecnico;
        this.asignacion = informacion.asignacion;
        this.busquedaSelect = informacion.apellidosNombres;
        this.movFechaEntrega = this.convertirFechaParaInput(
          informacion.movFechaEntrega
        );
        this.movFechaDevolucion = this.convertirFechaParaInput(
          informacion.movFechaDevolucion
        );

        this.hisMonAlquiler = informacion.hisMonAlquiler.toFixed(2);
      } else {
        this.resetFormulario();
      }

      this.mostrarModal = true;
    },
    convertirFechaParaInput(fecha) {
      if (!fecha) return "";
      const partes = fecha.split("/");
      return `${partes[2]}-${partes[1]}-${partes[0]}`;
    },
    resetFormulario() {
      this.editarRotac = {};

      this.movmov = "";
      this.movIdTrabajador = "";
      this.movObservacion = "";
      this.movDetTecnico = "";
      this.movFechaEntrega = "";

      this.busquedaSelect = "";

      this.hisMonAlquiler = "";
    },

    cerrarModal() {
      this.mostrarModal = false;
    },
    mandarTipDisp(event) {
      this.movTipDispositivo = event.target.value;
    },
    recogerIdDispo(event) {
      this.movIdDispositivo = event.target.value;
    },
    recogerIdTraba(event) {
      this.movIdTrabajador = event;
    },

    EscogerEmpresa(event) {
      console.log(event.target.value);
      this.idEmpresa = event.target.value;

      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${this.dniTrabajador}`
        )
        .then((r) => {
          console.log(r.data);
          this.CentroCosto = r.data;
        });
    },

    EscogerCentroCos(event) {
      console.log(event.target.value);
      this.CodCenCosto = event.target.value;
      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${event.target.value}&dniUser=${this.dniTrabajador}&idEmpresa=${this.idEmpresa}`
        )
        .then((r) => {
          this.SubCentroCosto = r.data;
        });
    },
    EscogerSubCen(event) {
      const idSeleccionado = parseInt(event.target.value);
      const subCentro = this.SubCentroCosto.find(
        (item) => item.id === idSeleccionado
      );
      this.CodSubCenCosto = subCentro.cenSubCentro;

      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.idEmpresa}&dniUser=${this.dniTrabajador}&codCentro=${subCentro.cenCodigo}&codSubCentro=${subCentro.cenSubCentro}`
        )
        .then((r) => {
          this.SubSubCentroCosto = r.data;
          console.log(r.data);
        });
    },
    EscogerSubSubCen(event) {
      this.axios
        .get(`SubSubCentro/ObtenerSububCentro/${event.target.value}`)
        .then((r) => {
          console.log(r.data);
          this.CodSubSubCentro = r.data[0].cenSubSubCodigo;
        });
    },

    async guardarModal() {
      const Guardar = {
        movTipDispositivo: this.movTipDispositivo,
        movIdDispositivo: this.movIdDispositivo,
        movIdTrabajador: this.movIdTrabajador,
        movObservacion: this.movObservacion,
        movDetTecnico: this.movDetTecnico,
        movFechaEntrega: `${this.movFechaEntrega}` + "T00:00:00",
        movFechaDevolucion: `${this.movFechaDevolucion}` + "T00:00:00",
        hisMonAlquiler: this.hisMonAlquiler,
        idUsuario: this.idUsuario,
      };

      if (this.modalModo === "agregar") {

        this.axios
          .post("Tecnologia/InsertarMovimientoEquipo", Guardar)
          .then((r) => {
            console.log(r.data);
            if (r.data.success) {
              Swal.fire({
                title: "¡Registro exitoso!",
                text: "La información se ha guardado correctamente.",
                icon: "success",
              });

              this.obtenerMovimientos();
              this.ObtenerDispositivoRotacion();
              this.ObtenerTrabajadoreMovimiento();
              this.cerrarModal();
            } else {
              Swal.fire({
                icon: "error",
                title: "Error al registrar",
                text: "No se Registro",
              });
            }
          });
      } else {
        Guardar.idMovEquipo = this.idMovEquipo;
        Guardar.asignacion = this.asignacion;
        this.axios
          .put("Tecnologia/ModificarMovimientoEquipo", Guardar)
          .then((r) => {
            console.log(r.data);
            if (r.data.success) {
              Swal.fire({
                title: "¡Registro exitoso!",
                text: "La información se ha guardado correctamente.",
                icon: "success",
              });
              this.obtenerMovimientos();
              this.ObtenerDispositivoRotacion();
              this.ObtenerTrabajadoreMovimiento();
              this.cerrarModal();
            } else {
              Swal.fire({
                icon: "error",
                title: "Error al registrar",
                text: "No se pudo Editar ",
              });
            }
          });
      }
    },
    eliminarSeleccionados() {
      this.movimientos = this.movimientos.filter(
        (m) => !this.selectedRows.includes(m)
      );
      this.selectedRows = [];
    },

    filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 900);
    },

    reporteSeguimientosExcel() {
      this.excelCarga = true;
      this.ReportRotacionDocumento = null;

      // Si ya hay una solicitud anterior, la cancelamos
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();

      this.axios
        .get(
          `ReportesExcel/ReporteMovDispositivo`,
          {
            params: { idTrabajador: this.idTrabajador },
            responseType: "blob",
            signal: this.abortController.signal // <-- señal agregada
          }
        )
        .then((response) => {
          this.ReportRotacionDocumento = response.data;
          this.excelCarga = false;
          console.log("Excel recibido:", response.data);
        })
        .catch((error) => {
          if (error.name === "CanceledError") {
            console.log("Solicitud cancelada");
          } else {
            console.error("Error al descargar reporte:", error);
          }
        })
        .finally(() => {
          this.excelCarga = false;
        });
    },


    descargarExcelSegui() {
      var fileURL = window.URL.createObjectURL(
        new Blob([this.ReportRotacionDocumento])
      );
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "Seguimiento_Dispositivos.xlsx");
      document.body.appendChild(fileLink);

      fileLink.click();
    },


  },
};
</script>

<style scoped>
.boton-estiloCuadrado {
  padding: 0.2rem 0.55rem;
  cursor: pointer;
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.3rem 0.55rem;
}

.input-group {
  max-width: 350px;
}

.row.mb-3 {
  margin-bottom: 1rem !important;
}

.tabla-estiloCompreso {
  padding: 0.3rem 0.55rem;
}

.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565c0;
}

.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

table,
tr,
h6 {
  page-break-inside: avoid;
}

.cursor-pointer {
  cursor: pointer;
}

#file-upload {
  display: none;
}

.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(16, 16, 16, 0.6);
  /* transparencia */
  backdrop-filter: blur(0.5px);
  /* efecto de desenfoque */
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Caja del modal */
.custom-modal {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 10px;
  padding: 4rem 5rem;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}



/* Texto del modal */
.text {
  color: #333;
  font-size: 0.95rem;
  font-weight: 500;
}
</style>
